import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "retweet",
  "use": "retweet-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"retweet\">\n  <defs>\n    <path id=\"retweet_retweet-a\" d=\"M5,13 L5,8 L7,8 L3.5,4 L0,8 L2,8 L2,14 C2,15.104 2.895,16 4,16 L13.482,16 L10.844,13 L5,13 Z M9.156,7 L6.518,4 L16,4 C17.104,4 18,4.897 18,6 L18,12 L20,12 L16.5,16 L13,12 L15,12 L15,7 L9.156,7 Z\" />\n  </defs>\n  <use xlink:href=\"#retweet_retweet-a\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol